import React from 'react';
import { trans } from '../../../localization/language';
import Success from '../../Success';

export default class DonePassword extends React.Component {
	render() {
		var title = trans('change_password_title');
		var message = trans('change_password_success');
		return (
			<Success title={title} message={message} />
		);
	}
}



// WEBPACK FOOTER //
// ./app/components/security/password/DonePassword.js